function Footer() {
    return (
        <footer className="w-full my-14" style={{ "height": "500px" }}>
        </footer>
    )
}


export default Footer;